import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { openRunAbTestModal } from '../../../actions/ModalActions';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RunAbTestMenuAction = ({
  name,
  interactiveId,
  isSmart,
  isPersonalized
}) => {
  const dispatch = useDispatch();
  const handleRunAbTest = () => {
    dispatch(openRunAbTestModal({
      name,
      interactiveId
    }));
  };
  const isDisabled = isSmart || isPersonalized;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actionMenu.abValidationMessage"
    }),
    placement: "bottom",
    disabled: !isDisabled,
    children: /*#__PURE__*/_jsxs(Button, {
      disabled: isDisabled,
      onClick: handleRunAbTest,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "actionMenu.runAbTest"
      }), /*#__PURE__*/_jsx(Badge, {
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "actionMenu.badge.beta"
        })
      })]
    })
  });
};
export default RunAbTestMenuAction;